<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  *ngIf="!dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ "fieldservice.noeventsfound" | translate }}</h2>
  </div>
</div>
<div
  [hidden]="!dataSource.data?.length"
  id="history-details">
  <div class="row">
    <div class="col col-sm-4">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="field-service-history-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="field-service-history-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div
      id="field-service-history-table"
      class="col bg-white u-shadow u-scroll--horizontal">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        multiTemplateDataRows
        class="c-table c-table--expandable">
        <ng-container matColumnDef="fieldServiceHistoryDetail">
          <th
            mat-header-cell
            *matHeaderCellDef>
            {{ "toolhistory.workorder" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let item"
            colspan="3"
            class="expandable-row-detail-cell">
            <div [@detailExpand]="item.expanded ? 'expanded' : 'collapsed'">
              <table
                #expandedRowDetailTable
                mat-table
                matSort
                #nestedMatSort="matSort"
                [dataSource]="getEventsDataSource(item.events, nestedMatSort)"
                class="detail-table">
                <ng-container
                  *ngFor="let col of eventColumns; index as i"
                  [matColumnDef]="col.key">
                  <th
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef>
                    {{ col.title | translate }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let item"
                    width="33%">
                    <ng-container [ngSwitch]="col.key">
                      <div *ngSwitchCase="'name'">{{ item.name | titlecase }}</div>
                      <div *ngSwitchCase="'date'">{{ item.date | date }}</div>
                      <div *ngSwitchCase="'docs'">
                        <span
                          class="c-download-link"
                          *ngFor="let doc of item.docs">
                          <download-file [file]="doc"></download-file>
                        </span>
                      </div>
                    </ng-container>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="eventColumnKeys"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: eventColumnKeys"></tr>
              </table>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="raNumber">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            {{ "toolhistory.workorder" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let job"
            (click)="toggleExpandRow(job)"
            class="c-table__group-header"
            [class.c-clickable]="job.events?.length"
            colspan="3"
            [class.is-toggled]="job.expanded">
            <i class="c-icon c-icon--toggle"></i>
            <span class="field-service-title">
              {{ job.raNumber }} ({{ job.startDate | date: "dd.MM.yyyy" }})
            </span>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="['raNumber']"></tr>
        <tr
          mat-row
          *matRowDef="let job; columns: ['raNumber']"
          class="c-table__row"></tr>
        <tr
          mat-row
          *matRowDef="let job; columns: ['fieldServiceHistoryDetail']; when: isExpansionDetailRow"
          class="expandable-row"
          [class.expanded-row]="job.expanded"></tr>
      </table>
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
